import { Grid } from '@material-ui/core'
import styled from 'styled-components'

export const StyledGrid = styled(Grid)`
  margin-bottom: 20px;
`
